import React from "react";
import { Link } from "react-router-dom";

import "./index.css";

export default function Menu() {
  const manualLink =
    "https://drive.google.com/file/d/1NYpWCd0lljWGdD4OmNjktItyym8KBrv8/view?usp=sharing";

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <h2 className="navbar-brand" href="/">
          Links
        </h2>
        <ul className="navbar-nav navbar-links-list">
          <div id="internal-links">
            <Link to={"/novo"}>
              <li className="nav-item nav-item-link">Novo link</li>
            </Link>

            <Link to={"/lista"}>
              <li className="nav-item nav-item-link">Todos os links</li>
            </Link>
          </div>
          <div id="questions">
            <li className="nav-item nav-item-link" id="manual-link">
              <span>
                Ficou com dúvida?{" "}
                <a
                  href={manualLink}
                  target="_blank"
                  className="external-link"
                  rel="noreferrer"
                >
                  Clique aqui
                </a>
              </span>
            </li>
          </div>
        </ul>
      </nav>
    </>
  );
}
